import React, { useState } from 'react'
import { useIntl } from 'react-intl';
import { Form, Button, Col, Row, InputNumber, DatePicker, Card, Radio, Modal, notification, message} from 'antd';
import dayjs from 'dayjs';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import LoadingControl from './Loading';
import '../App.css';

import { formatBytes, sendPost } from '../utils/utils';

const layout = {
    labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 16,
      },
};

const DBPanelInformation = (props) => {  
    const intl = useIntl();
    const [form] = Form.useForm();

    return (
            <Form form={form} 
                layout="horizontal"
                {... layout}
            >
                <Form.Item
                    name="DbType"
                    label={intl.formatMessage({ id: "Type" })}
                    labelAlign="center"
                >
                    <span className="ant-popover-title">{props.settings.DbType}</span>
                </Form.Item>

                <Form.Item
                    name="DbStatus"
                    label={intl.formatMessage({ id: "SuppliesTable.status" })}
                >
                    <span className="ant-popover-title">{props.settings.DbStatus}</span>
                </Form.Item>

                <Form.Item
                    name="DbInfo"
                    label={intl.formatMessage({ id: "Detailed" })}
                >
                    <span className="ant-form-text">{props.settings.DbInfo}</span>
                </Form.Item>
            </Form>
            );
}

const DBPanelCurrentSize = (props) => {  
    const intl = useIntl();
    const [form] = Form.useForm();

    return (
            <Form form={form} 
                    layout="horizontal"
                    {... layout}
                >
                <Form.Item
                    name="DbSize"
                    label={intl.formatMessage({ id: "TotalSize" })}
                >
                    <span className="ant-popover-title">{formatBytes(props.settings.DbSize)}</span>
                </Form.Item>

                <Form.Item
                    name="DbRecordsCount"
                    label={intl.formatMessage({ id: "TotalRecords" })}
                >
                    <span className="ant-popover-title">{props.settings.DbRecordsCount}</span>
                </Form.Item>

                <Form.Item
                    name="DbJobDataSize"
                    label={intl.formatMessage({ id: "TotalImagesSize" })}
                >
                    <span className="ant-popover-title">{formatBytes(props.settings.DbJobDataSize)}</span>
                </Form.Item>

                <Form.Item
                    name="MaxJobAge"
                    label={intl.formatMessage({ id: "OldestRecord" })}
                >
                    <span className="ant-popover-title">{props.settings.MaxJobAge} {intl.formatMessage({ id: "DaysAgo" })}</span>
                </Form.Item>

                <Form.Item
                    name="MaxImageAge"
                    label={intl.formatMessage({ id: "OldestImageRecord" })}
                >
                    <span className="ant-popover-title">{props.settings.MaxImageAge} {intl.formatMessage({ id: "DaysAgo" })}</span>
                </Form.Item>

                <Form.Item
                    name="AvgJobImageSize"
                    label={intl.formatMessage({ id: "AverageImageSize" })}
                >
                    <span className="ant-popover-title">{formatBytes(props.settings.AvgJobImageSize)}</span>
                </Form.Item>

                <Form.Item
                    name="MaxJobImageSize"
                    label={intl.formatMessage({ id: "BiggestImageSize" })}
                >
                    <span className="ant-popover-title">{formatBytes(props.settings.MaxJobImageSize)}</span>
                </Form.Item>
            </Form>
            );
}

const DBPanelStorageSettings = (props) => {
    
    const [state, setState] = useState({
        changed: false
    });

    const intl = useIntl();
    const [form] = Form.useForm();

    const onInputChange = (changedField) => {

        setState({changed: true});
    }

    function onSubmit() {
        let settings = form.getFieldsValue(true);
        sendPost('/db_settings', settings, intl);
    }

    return (
            <Form form={form} 
                    layout="horizontal"
                    initialValues={{
                        MaxDaysToStoreJobs: props.settings.MaxDaysToStoreJobs,
                        MaxDaysToStoreImages: props.settings.MaxDaysToStoreImages,
                        MaxSizeToStoreImages: props.settings.MaxSizeToStoreImages
                    }}
                    {... layout}
                >
                <Form.Item label={intl.formatMessage({ id: "DocumentsStoragePeriod" })}>
                    <Form.Item name="MaxDaysToStoreJobs" noStyle>
                        <InputNumber min={0} addonAfter={intl.formatMessage({ id: "days" })} onChange = {(e) => onInputChange(e)}/>
                    </Form.Item>
                </Form.Item>

                <Form.Item label={intl.formatMessage({ id: "ImagesStoragePeriod" })}>
                    <Form.Item name="MaxDaysToStoreImages" noStyle>
                        <InputNumber min={0} addonAfter={intl.formatMessage({ id: "days" })} onChange = {(e) => onInputChange(e)}/>
                    </Form.Item>
                </Form.Item>

                <Form.Item label={intl.formatMessage({ id: "MaxImagesSize" })}>
                    <Form.Item name="MaxSizeToStoreImages" noStyle>
                        <InputNumber min={0} addonAfter={intl.formatMessage({ id: "Gb" })} onChange = {(e) => onInputChange(e)}/>
                    </Form.Item>
                </Form.Item>

                <Form.Item label=" " colon={false}>
                        <Button type="primary" disabled={!state.changed} onClick = {onSubmit}>{intl.formatMessage({ id: "Submit" })}</Button>
                </Form.Item>
            </Form>
            );
}

const DBPanelClearData = (props) => {
    
    const fromDate = dayjs().subtract(1, 'year').startOf('year');
    const toDate = dayjs().subtract(1, 'year').endOf('year');    

    const [dateRange, setDateRange] = useState([fromDate, toDate]);
    const [selectedOption, setSelectedOption] = useState(1);
    const [deletionIsActive, setSetDeleteionActive] = useState();

    const intl = useIntl();

    const handleConfirmDelete = () => {
        let request = {
            dateFrom: dateRange[0].unix(),
            dateTo: dateRange[1].unix(),
            deleteAllData: selectedOption === 1
        };

        setSetDeleteionActive(true);

        axios.post("/clear_data", request)
        .then(response => {
            notification['success']({
            message: intl.formatMessage({id:'Success'}),
            description: intl.formatMessage({id: 'SuccessDeleteResult'}, {count: response.data.count}),
            duration: 3,
            onClose: () => {
                window.location.reload();
            }
            });
        })
        .catch(err => {
            notification['error']({
            message: intl.formatMessage({id: 'Error'}),
            description: err.message,
            duration: 0
            });
        })
        .finally(() => {
            setSetDeleteionActive(false);
        }
        );
    };

    const handleDelete = () => {
        if (!dateRange || !dayjs.isDayjs(dateRange[0]) || !dayjs.isDayjs(dateRange[1])) {
            message.error(intl.formatMessage({id: 'InvalidDateRange'}));
            return;
        }            

        Modal.confirm({
            title: <intl.formatMessage id="ClearDatabaseRecords" />,
            icon: <ExclamationCircleOutlined />,
            content: <intl.formatMessage id="ClearDatabaseConfirmationText" />,
            autoFocusButton: null,
            onOk() {handleConfirmDelete()},
          });
    };

    if (deletionIsActive) {
        return (
                <div className="style-center"><LoadingControl/></div>
                );      
    }
    else {
        return (
                <div>
                    <DatePicker.RangePicker
                    style={{ width: '100%', marginBottom: 16 }}
                    value={dateRange}
                    onChange={(dates) => setDateRange(dates ? [dates[0], dates[1]] : null)}
                    format="DD MMMM YYYY"
                    />
                    <br />
                    <div style={{ marginBottom: 16 }}>
                    <Radio.Group
                        value={selectedOption}
                        onChange={(e) => setSelectedOption(e.target.value)}
                        style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
                        >
                        <Radio value={1} style={{ textAlign: 'center' }}>
                            <intl.formatMessage id="DeleteAllData" />
                        </Radio>
                        <Radio value={2} style={{ textAlign: 'center' }}>
                            <intl.formatMessage id="DeleteOnlyDocumentContent" />
                        </Radio>
                        </Radio.Group>
                    </div>
                    <div style={{ display: 'flex',  justifyContent: 'center', gap: 8 }}>
                    <Button danger onClick={handleDelete}>
                        <intl.formatMessage id="Delete" />
                    </Button>
                    </div>
                </div>
                );
    }
}

const DBSettings = (props) => {  
    const intl = useIntl();

    return (
            <div className="db-settings">
                <Row gutter={16} align="stretch" style={{ marginBottom: 16 }}>
                    <Col span={10}>
                        <Card title={intl.formatMessage({ id: "Information" })} variant="outlined" style={{ height: '100%' }}>
                            <DBPanelInformation settings={props.settings} />
                        </Card>
                    </Col>
                    <Col span={10}>    
                        <Card title={intl.formatMessage({ id: "CurrentSize" })} variant="outlined" style={{ height: '100%' }}>
                            <DBPanelCurrentSize settings={props.settings} />
                        </Card>
                    </Col>
                </Row>
                <Row gutter={16} align="stretch" style={{ marginBottom: 16 }}>    
                    <Col span={10}>    
                        <Card title={intl.formatMessage({ id: "StorageSettings" })} variant="outlined" style={{ height: '100%' }}>
                            <DBPanelStorageSettings settings={props.settings} />
                        </Card>
                    </Col>
                    <Col span={10}>    
                        <Card title={intl.formatMessage({ id: "DataDeletion" })} variant="outlined" style={{ height: '100%' }}>
                            <DBPanelClearData settings={props.settings} />
                        </Card>
                    </Col>
                </Row>
            </div>
        );   
    
}
  
export default DBSettings;